import { Injectable } from "@angular/core";
import { OEModelGetterService } from "./oe-model-getter.service";

@Injectable()
export class OEModelSyncService {
  /**********************************************************************/
  /* DATA */
  private control: any = {
    blockUpdateForRefIds: [],
  };

  /**********************************************************************/
  /* CONSTRUCTOR  */

  constructor(private getter: OEModelGetterService) {}

  /**********************************************************************/
  /* MODEL UPDATE BLOCKING */

  /**
   * Model Update Blocking mechanism for Modify / Modify Info / Duplicate
   * -------------------------------------------------------------------
   * Note: This mechanism was implemented as fix for https://www.bcdfx.com/ijira/browse/OMS-25307
   * ---------
   * Cause: certain interface controls (like client intent) propagate the default value on initialization, thus updating the model.
   * 		  Since the loading of orderData for Modify / Modify Info / Duplicate is performed before the initialization of the order entry screen,
   * 		  the default value overwrites the loaded value.
   * ---------
   * Solution: An update blocking mechanism was implemented so that in certain cases (Modify / Modify Info / Duplicate loading of OrderData) the
   * 		  propagation is stopped in the _oeActions service and the model is not updated. How it works:
   * 		  - After the server loaded OrderData is processed, a list of refIds (based on OrderData set) is stored in the blockList (this.control.blockUpdateForRefIds)
   * 		  - A guard (using isUpdateBlocked() function) is placed on the update method of the interface control that needs to be prevented from overwriting
   * 			the loaded data. So when update is triggered on initialization the propagation is stopped at the _oeActions and does not reach getter.
   * 		  - When the server loaded OrderData is loaded in the interface controls, the block list is cleared, and from this point on updates from interface controls
   * 			are propagated normally.
   * ---------
   * Note: Affected interface controls: request rate, client intent, markup, fixed ccy
   */
  public addToBlockUpdateList(refId: string): void {
    let blockList = this.getter.getStrategyNodesListRoot(refId);
    this.control.blockUpdateForRefIds = this.control.blockUpdateForRefIds.concat(blockList);
  }
  public removeFromBlockUpdateList(refId: string): void {
    let unblockList = this.getter.getStrategyNodesListRoot(refId);
    this.control.blockUpdateForRefIds = this.control.blockUpdateForRefIds.filter(
      (x) => !unblockList.includes(x),
    ); // array difference
  }

  public isUpdateBlocked(refId: string): boolean {
    return this.control.blockUpdateForRefIds.includes(refId);
  }
}
